export default __webpack_public_path__ + "static/media/google-icon.8a10d69b.svg";